module.exports = __webpack_public_path__ + "officialStatic/img/weCode.0eb0d26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/weCode.png
// module id = c0XK
// module chunks = 0